<template>
    <div class="container">
    <z-steps :active="curIndex">
      <z-step
        class="step"
        v-for="(item, index) in horizontal"
        :key="index"
        :title="item.title"
        :image-active="item.imageActive"
        :image-deactive="item.imageDeactive"
      />
    </z-steps>
    <div class="subpage">
      <transition name="z-slide-left">
        <License v-if="license"></License>
      </transition>
      <transition name="z-slide-left">
        <Permit v-if="permit"></Permit>
      </transition>
      <transition name="z-slide-left">
        <OtherQuality v-if="otherquality"></OtherQuality>
      </transition>
      <transition name="z-slide-left">
        <Result v-if="result" :status="resultStatus"></Result>
      </transition>
    </div>
    </div>
</template>
<script>
import native from '@zz-common/native-adapter'
import '@zz-common/zz-ui/lib/style/animation.scss';
import { Step, Steps } from '@zz-common/zz-ui'
import License from './components/license/index.vue'
import Permit from './components/permit/index.vue'
import OtherQuality from './components/otherquality/index.vue';
import Result from './components/result/index.vue'
import { queryParams } from '../../lib/utils'
const query = queryParams()
export default {
  name: 'NewQuality',
  components: {
    zStep: Step,
    zSteps: Steps,
    License,
    Permit,
    OtherQuality,
    Result
  },
  provide() {
    return {
      $rootEle: this
    }
  },
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode || 'unknow',
      permitType: query.permitType || this.$route.query.permitType || 'unknow',
      productQuaType: query.productQuaType || this.$route.query.productQuaType || 'unknow',
      infoId: query.infoId || this.$route.query.infoId || 'unknow',
      reasonId: query.reasonId || this.$route.query.reasonId || 'unknow',
      horizontal: [
        {
          title: '营业执照',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '经营许可',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '其他资质',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '提交成功',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        }
      ],
      license: true,
      permit: false,
      otherquality: false,
      result: false,
      curIndex: 0,
      submitData: {},
      resultStatus: 'deal'
    }
  },
  mounted() {
    native.setTitle({
      title: '资质提交'
    })
  },
  methods: {
    stateChange(curstate, nextstate, nextIndex) {
      this.$data[curstate] = false
      this.$data[nextstate] = true
      this.curIndex = nextIndex
    },
    setSubmitData(key, val) {
      this.submitData[key] = val
    },
    setResultStatus(val) {
      this.resultStatus = val
    }
  }

}
</script>
<style lang="less" scoped>
  @import 'index.less';
</style>